export const APP_VERSION =
  typeof __ECO_APP_VERSION__ !== "undefined" ? __ECO_APP_VERSION__ : "dev";
export const BUILD_TIME =
  typeof __ECO_BUILD_TIME__ !== "undefined" ? __ECO_BUILD_TIME__ : "";
export const GIT_SHA =
  typeof __ECO_GIT_SHA__ !== "undefined" ? __ECO_GIT_SHA__ : "";

export function formatBuildTime(isoString) {
  if (!isoString) return "";

  try {
    return new Date(isoString).toLocaleString();
  } catch {
    return isoString;
  }
}
